module.exports = "<div class=\"divClub\">\r\n    Esta es la pantalla del club\r\n</div>\r\n"